const CitiesInIraq = [
    "Baghdad",
    "Mosul",
    "Basra",
    "Erbil",
    "Sulaymaniyah",
    "Najaf",
    "Karbala",
    "Kirkuk",
    "Nasiriyah",
    "Amarah",
    "Diwaniyah",
    "Samawah",
    "Hillah",
    "Ramadi",
    "Fallujah",
    "Tikrit",
    "Kut",
    "Baqubah",
    "Tal Afar",
    "Sinjar"
  ];
  export default CitiesInIraq
  
